// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Input, Skeleton } from '@/ui';
import { Form, FormItem } from '@/components';
import { FormColumn, FormWrapper, StyledButton, StyledTitle } from '../Styled';
import { CheckmarkIcon } from '@/icons';

// Models
import { IAdminProfile } from '@/models/admins.model';

// Helpers
import { AdminProfileFieldsNames, TAdminProfileFormValues } from '../../helpers/types';
import { useAdminProfileRules } from '../../hooks/useValidationRules';

interface IAdminProfileForm {
  handleSubmit: (values: TAdminProfileFormValues) => void;
  isLoading: boolean;
  initialValues: IAdminProfile | null;
}

const AdminProfileForm = ({ handleSubmit, isLoading, initialValues }: IAdminProfileForm) => {
  const { t } = useTranslation(['profile', 'common']);
  const rules = useAdminProfileRules();

  const placeholder = t('common_placeholder_input', { ns: 'common' });

  if (isLoading) return <Skeleton />;

  return (
    <FormWrapper>
      <StyledTitle>{t('profile_profile_data')}</StyledTitle>

      <Form onFinish={handleSubmit} initialValues={initialValues ?? {}}>
        <FormColumn>
          <FormItem
            name={AdminProfileFieldsNames.FIRST_NAME}
            label={t('profile_first_name')}
            rules={rules[AdminProfileFieldsNames.FIRST_NAME]}
          >
            <Input placeholder={placeholder} />
          </FormItem>
          <FormItem
            name={AdminProfileFieldsNames.LAST_NAME}
            label={t('profile_last_name')}
            rules={rules[AdminProfileFieldsNames.LAST_NAME]}
          >
            <Input placeholder={placeholder} />
          </FormItem>
          <FormItem name={AdminProfileFieldsNames.ID} label={t('ID')}>
            <Input placeholder={placeholder} disabled />
          </FormItem>
          <FormItem name={AdminProfileFieldsNames.EMAIL} label={t('profile_email')}>
            <Input placeholder={placeholder} disabled />
          </FormItem>
        </FormColumn>

        <StyledButton htmlType="submit" loading={isLoading}>
          <CheckmarkIcon /> {t('profile_save')}
        </StyledButton>
      </Form>
    </FormWrapper>
  );
};

export default AdminProfileForm;
